import axios, { AxiosRequestConfig } from "axios";

type LogData = {
  uid: string; // An ID unique for each user.(The same id appended to the label sent to kayak) | REQUIRED
  label: string; // The label sent to kayak | REQUIRED
  distinctId?: string; // The distinct_id used by mixpanel if available
  route?: string; // Can take values “organic”, “ads”, “unknown” | REQUIRED
  countryCode?: string; // Country code of the user
  gclid?: string; // Google Click ID
  msclkid?: string; // Microsoft Click ID
  fbclid?: string; // Facebook Click ID
  twclid?: string; // Twitter Click ID
  ttclid?: string; // Tiktok Click ID
  adid?: string; // Adjust ID
  lastSeen?: Date; // Last time the user was seen
  currency?: string; // Preferred currency of the user
};

const productionAppTitle = "d1_web_car";

export function saveUser({
  uid,
  label,
  distinctId,
  route = "unknown",
  countryCode,
  gclid,
  msclkid,
  fbclid,
  twclid,
  ttclid,
  adid,
  lastSeen,
  currency,
}: LogData) {
  const data = {
    productionAppTitle,
    label,
    uid,
    distinctId,
    route,
    countryCode,
    gclid,
    msclkid,
    fbclid,
    twclid,
    ttclid,
    adid,
    lastSeen,
    currency,
  };

  const userConfig: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_USERDATA_API_BEARER_TOKEN}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    // body: data,
  };

  try {
    // console.log(userConfig, data);
    axios.post(`${process.env.NEXT_PUBLIC_USERDATA_API_URL}/user/`, data, userConfig)
      .then((res) => { });
  } catch (error) {
    console.log("Error saving data: ", error);
  }
}
